export enum GameCategory {
	NBA = 'f5a6b7c8-9d0e-1f2a-3b4c-5d6e7f8a9b0c',
	NFL = 'f101aa12-bc34-4def-8123-123456789001',
	MLB = 'a2b3c4d5-e6f7-8901-2345-6789abcdef01',
	EPL = 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
	UCL = '9b1deb4d-3b7d-4c2f-8d2a-3a1f7c6e9b5f',
	NCAAB = '3fa85f64-5717-4b22-9e3e-1c6f8a9d7b2c',
	NHL = 'b4c5d6e7-f8a9-0b1c-2d3e-4f5a6b7c8d9e',
	PGA = 'd3e4f5a6-7b8c-9d0e-1f2a-3b4c5d6e7f8a',
	FIFA = 'a7c3f1d2-8e4b-4c9a-b6d1-2f5e8a7c9b3d',
	ATP = 'c8e2b4f6-9a1d-4e7c-8b3f-2d5a9c6e7f4b',
	WTA = 'e1f3a5b7-8c2d-4a9e-7f5b-1c4d8e6a2f9c',
	TENNIS = 'c2d3e4f5-6a7b-8c9d-0e1f-2a3b4c5d6e7f',
	NCAAF = 'f1e2d3c4-b5a6-7890-1234-56789abcdef0',
	POLITICS = 'e7a1c2d3-4b5f-4a6e-9c8d-1f2e3a4b5c6d',
}

export const TENNIS_GAME_CATEGORIES = new Set<GameCategory>([
	GameCategory.ATP,
	GameCategory.WTA,
	GameCategory.TENNIS,
]);

export const isTennisGameCategory = (categoryId?: string | null): boolean =>
	!!categoryId && TENNIS_GAME_CATEGORIES.has(categoryId as GameCategory);

export const SOCCER_GAME_CATEGORIES = new Set<GameCategory>([
	GameCategory.FIFA,
	GameCategory.EPL,
	GameCategory.UCL,
]);

export const FOOTBALL_GAME_CATEGORIES = new Set<GameCategory>([
	GameCategory.NFL,
	GameCategory.NCAAF,
]);

export const AVERAGE_SCORING_CATEGORIES = new Set<GameCategory>([
	GameCategory.EPL,
	GameCategory.NFL,
]);

export const isAverageScoringCategory = (categoryId?: string | null): boolean =>
	!!categoryId && AVERAGE_SCORING_CATEGORIES.has(categoryId as GameCategory);

export const AVERAGE_SCORING_MIN_PREDICTIONS = 5;

export enum BullQueuesEnum {
	RequestToOddsService = 'REQUEST_TO_ODDS_SERVICE_QUEUE',
	RequestToAPIService = 'REQUEST_TO_API_SERVICE_QUEUE',
	MarketOddsService = 'MARKET_ODDS_SERVICE_QUEUE',
	EspnMarketService = 'ESPN_MARKET_QUEUE',
}

export enum EspnMarketJobsEnum {
	CheckGameCompletions = 'ESPN_CHECK_GAME_COMPLETIONS',
}

export enum gameCategoryPeriodEnum {
	Day = 'Day',
	Week = 'Week',
}

export enum StreamType {
	ODDS = 'odds',
	RESULTS = 'results',
}

export enum RequestToAPIJobsEnum {
	RequestToAPI = 'REQUEST_TO_API',
}

export enum MarketJobsEnum {
	UpdateMarkets = 'UPDATE_MARKETS',
	UpdateMarketOdds = 'UPDATE_MARKET_ODDS',
}

export enum RequestToOddsJobsEnum {
	RefreshGameList = 'REFRESH_GAMES_LIST',
	GenerateMarketsForGame = 'GENERATE_MARKETS_FOR_GAME',
	RefreshEventMatches = 'REFRESH_EVENT_MATCHES',
	RefreshMatchResults = 'REFRESH_MATCH_RESULTS',
	PullEventSlates = 'PULL_EVENT_SLATES',
	PullSessionSlate = 'PULL_SESSION_SLATE',
	GenerateFuturesMarkets = 'GENERATE_FUTURES_MARKETS',
	SimulateGameResult = 'SIMULATE_GAME_RESULT',
}

export enum ODDS_SERVICE_JOB_TYPE {
	GAMES_LIST_REFRESHED = 'GAMES_LIST_REFRESHED',
	NEW_MARKETS_BY_GAME_GENERATED = 'NEW_MARKETS_BY_GAME_GENERATED',
	UPDATE_MARKETS = 'UPDATE_MARKETS',
	REFRESHED_EVENT_MATCHES = 'REFRESHED_EVENT_MATCHES',
	PREPARE_CALCULATE_USERS_SCORE = 'PREPARE_CALCULATE_USERS_SCORE',
	PREPARE_DELETE_LEADERBOARD_CACHE = 'PREPARE_DELETE_LEADERBOARD_CACHE',
	PREPARE_TRY_COMPLETE_H2H = 'PREPARE_TRY_COMPLETE_H2H',
	GAME_STATUS_NOTIFICATION = 'GAME_STATUS_NOTIFICATION',
	FUTURES_MARKETS_GENERATED = 'FUTURES_MARKETS_GENERATED',
	AVAILABLE_FUTURES_LISTED = 'AVAILABLE_FUTURES_LISTED',
	PREPARE_RECALCULATE_PROBABILITY_LEADERBOARD = 'PREPARE_RECALCULATE_PROBABILITY_LEADERBOARD',
	PREPARE_DELETE_PROBABILITY_LEADERBOARD_CACHE = 'PREPARE_DELETE_PROBABILITY_LEADERBOARD_CACHE',
	MATCH_UPDATED = 'MATCH_UPDATED',
	MATCH_RESULTS_REFRESHED = 'MATCH_RESULTS_REFRESHED',
}

export enum MarketOutcome {
	Won = 'won',
	Lost = 'lost',
	Pending = 'pending',
	Void = 'void',
}

export enum PeriodType {
	Game = 'game',
	Half1 = 'half_1',
	Half2 = 'half_2',
	Period1 = 'period_1',
	Period2 = 'period_2',
	Period3 = 'period_3',
	Period4 = 'period_4',
	Period5 = 'period_5',
	Period6 = 'period_6',
	Period7 = 'period_7',
	Period8 = 'period_8',
	Period9 = 'period_9',
	Period10 = 'period_10',
	FirstPeriod3 = 'first_period_3',
	FirstPeriod7 = 'first_period_7',
}
